module.exports = __webpack_public_path__ + "img/icon-11.34b99398.svg";